import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconAlertCircle } from '#src/atoms/icons/system/iconAlertCircle.ts';
import { iconCheckCircle } from '#src/atoms/icons/system/iconCheckCircle.ts';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyM, BodyS, HeadlineXS } from '#src/atoms/typography/index.tsx';
import { Input } from '#src/components/form/Form/IntlTelInput/index.tsx';
import {
  SecurityCheckTab,
  useAccountSecurityCheckContext,
} from '#src/contexts/accountSecurityCheck/index.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { glossary } from '#src/lib/glossary.ts';

export const PhoneNumber = () => {
  const { setSecurityCheckTab, setOnBackTarget, setUnverifiedPhoneNumber } =
    useAccountSecurityCheckContext();
  const { currentUser } = useCurrentUserContext();
  if (!currentUser) return null;

  const {
    phoneNumber,
    unverifiedPhoneNumber,
    phoneNumberVerificationRequested,
  } = currentUser;

  const addOrVerify = () => {
    if (phoneNumberVerificationRequested) {
      setSecurityCheckTab(SecurityCheckTab.VERIFY_PHONE_NUMBER);
      setOnBackTarget(SecurityCheckTab.ADD_PHONE_NUMBER);
      setUnverifiedPhoneNumber(unverifiedPhoneNumber!);
    } else {
      setSecurityCheckTab(SecurityCheckTab.ADD_PHONE_NUMBER);
    }
  };

  return (
    <Vertical gap={2}>
      <Vertical>
        <Horizontal>
          {phoneNumber ? (
            <FontAwesomeIcon
              icon={iconCheckCircle}
              color="var(--c-onBase-success)"
            />
          ) : (
            <FontAwesomeIcon icon={iconAlertCircle} color="var(--c-red-500)" />
          )}
          <HeadlineXS as="h6" color="var(--c-white)">
            <FormattedMessage defaultMessage="Phone number" />
          </HeadlineXS>
        </Horizontal>
        {!phoneNumber && (
          <BodyS color="var(--c-nd-600)">
            <FormattedMessage defaultMessage="Sorare uses phone numbers for security and anti-fraud purposes. It also helps our support team verify your identity in case you’ve lost your authentication device and recovery code." />
          </BodyS>
        )}
      </Vertical>
      {!!currentUser.phoneNumber && (
        <Input
          defaultPhone={currentUser.phoneNumber}
          noBorder
          disabled
          hideDetails
        />
      )}
      {!phoneNumber && (
        <BodyM color="var(--c-link)">
          <button type="button" onClick={addOrVerify}>
            <FormattedMessage {...glossary.addPhoneNumber} />
          </button>
        </BodyM>
      )}
    </Vertical>
  );
};
